import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import _uniqueId from 'lodash/uniqueId';

import { className } from '../../../utils/GlobalCssProxy';
import { TEMPLATES } from '../../../stores/profile/get-profile-template';
import { urls } from '../../../utils/url-helper';

import useProfileAppContext from '../../../stores/profile/use-profile-app-context';

const PARAM_BY_TEMPLATE = {
  [TEMPLATES.afterTaxAnnuity]: 'ata',
  [TEMPLATES.afterTaxAnnuityMoneyMarket]: 'ataMM',
  [TEMPLATES.collectiveInvestmentTrust]: 'MFNP', // per TIAA-12356, CIT's Purple boxes match Non-Prop MF.
  [TEMPLATES.fixedAnnuityOther]: 'fixAnnOth',
  [TEMPLATES.fixedAnnuityTiaaTraditional]: 'fixAnnTTra',
  [TEMPLATES.fixedAnnuityTiaaStableValue]: 'TSV',
  [TEMPLATES.mutualFund]: 'MF',
  [TEMPLATES.mutualFundMoneyMarket]: 'MFMM',
  [TEMPLATES.mutualFundNonProp]: 'MFNP',
  [TEMPLATES.mutualFundNonPropMoneyMarket]: 'MFNP',
  [TEMPLATES.none]: 'other',
  [TEMPLATES.other]: 'other',
  [TEMPLATES.otherMoneyMarket]: 'otherMM',
  [TEMPLATES.retirePlus]: 'retPlus',
  [TEMPLATES.variableAnnuityCref]: 'varAnnCref',
  [TEMPLATES.variableAnnuityCrefMoneyMarket]: 'varAnnCrefMM',
  [TEMPLATES.variableAnnuityOther]: 'varAnnOth',
  [TEMPLATES.variableAnnuityTiaaAccess]: 'varAnnTAcc',
  [TEMPLATES.variableAnnuityTiaaAccessNonProp]: 'varAnnTAcc',
  [TEMPLATES.variableAnnuityTiaaAccessMoneyMarket]: 'varAnnTAccMM',
  [TEMPLATES.variableAnnuityTiaaRealEstate]: 'varAnnTRE'
};

const VERSION_PARAM_BY_SECTION = {
  performance: '1.0',
  characteristics: '2.0',
  allocation: '3.0'
};

const getSrc = ({ section, template }) => {
  const templateParam = PARAM_BY_TEMPLATE[template];
  const versionParam = VERSION_PARAM_BY_SECTION[section];

  const queryString = [
    templateParam && `template=${templateParam}`,
    versionParam && `version=${versionParam}`
  ]
    .filter(Boolean)
    .join('&');

  return urls.public.asset(`pages/adhesion/?${queryString}`);
};

const Adhesion = ({ section }) => {
  const { template } = useProfileAppContext();

  const iframeName = useRef(`adhesion-container-${_uniqueId()}`);
  const [minHeight, setMinHeight] = useState();

  useEffect(() => {
    function handleMessage(e) {
      if (!(e.data && e.data.name === iframeName.current)) {
        return;
      }

      if (e.data.adhesionIframeDimensions && e.data.adhesionIframeDimensions.height) {
        setMinHeight(`${e.data.adhesionIframeDimensions.height}px`);
      }
    }
    window.addEventListener('message', handleMessage);

    return function cleanupListener() {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  return (
    <iframe
      title="Adhesion content"
      style={{ minHeight }}
      scrolling="no"
      name={iframeName.current}
      src={getSrc({ section, template })}
      {...className('iframe-overflow', 'border-0', 'h-100', 'w-100', 'd-print-none')}
      tabIndex={'0'}
    />
  );
};

const AdhesionAllocation = () => <Adhesion section="allocation" />;
const AdhesionCharacteristics = () => <Adhesion section="characteristics" />;
const AdhesionPerformance = () => <Adhesion section="performance" />;

Adhesion.Allocation = AdhesionAllocation;
Adhesion.Characteristics = AdhesionCharacteristics;
Adhesion.Performance = AdhesionPerformance;

Adhesion.propTypes = {
  section: PropTypes.string
};

export default Adhesion;
